<template>
    <div class="container">
        <legend>プライバシーポリシー</legend>
        <div class="rule">
            貸し本棚（以下「当サービス」といいます）は、本ウェブサイト上で提供するサービスにおいて、ユーザーの個人情報の保護を重要な責務と考え、以下のとおりプライバシーポリシーを定めます。

            <h4>第1条（個人情報の定義）</h4>
            <div class="mb-3">
                「個人情報」とは、個人情報保護法に定める、生存する個人に関する情報であり、氏名、メールアドレス、その他特定の個人を識別できる情報を指します。
            </div>
            <h4>第2条（個人情報の収集方法）</h4>
            <div class="mb-3">
                当サービスは、ユーザーが利用登録を行う際に、メールアドレス等の個人情報を収集することがあります。
                また、利用状況やお問い合わせ履歴を記録する場合があります。
            </div>
            <h4>第3条（個人情報の利用目的）</h4>
            <div class="mb-3">
                収集した個人情報は、以下の目的で利用します：
                <ol>
                    <li>サービスの提供・運営</li>
                    <li>ユーザーからのお問い合わせへの対応</li>
                    <li>サービスに関する重要なお知らせや更新情報の通知</li>
                    <li>メンテナンス、重要なお知らせなど必要に応じたご連絡のため</li>
                    <li><router-link to="/terms-of-use">利用規約</router-link>に違反したユーザーや、不正・違反行為の防止および対応</li>
                    <li>その他上記に付随する目的</li>
                </ol>
            </div>
            <h4>第4条（利用目的の変更）</h4>
            <div class="mb-3">
                利用目的の変更は、当初の目的と関連性があると合理的に認められる範囲で行います。変更後の利用目的は、ウェブサイト上で公表します。
            </div>
            <h4>第5条（個人情報の第三者提供）</h4>
            <div class="mb-3">
                当サービスは、次に掲げる場合を除き、第三者に個人情報を提供することはありません：
                <ol>
                    <li>法令に基づく場合</li>
                    <li>人の生命・身体・財産の保護が必要な場合で、本人の同意を得ることが困難な場合</li>
                    <li>業務委託に伴い、必要な範囲で個人情報の取扱いを委託する場合</li>
                    <li>
                        合併等による事業承継に伴う提供の場合
                    </li>
                </ol>
            </div>
            <h4>第6条（個人情報の開示）</h4>
            <div class="mb-3">
                ユーザー本人から開示請求があった場合、遅滞なく対応いたします。ただし、以下の場合は開示しないことがあります：
                <ol>
                    <li>本人または第三者の権利・利益を害するおそれがある場合</li>
                    <li>サービスの運営に著しい支障を及ぼす場合</li>
                    <li>その他法令に違反する場合</li>
                </ol>
            </div>
            <h4>第7条（個人情報の訂正および削除）</h4>
            <div class="mb-3">
                ユーザーは、自身の個人情報の訂正・削除を希望する場合、当サービス所定の方法により請求できます。
                当サービスは、請求に合理的理由があると判断した場合、遅滞なく対応し、その旨を通知します。
            </div>
            <h4>第8条（個人情報の利用停止等）</h4>
            <div class="mb-3">
                ユーザーが、個人情報の不正取得や利用目的の逸脱を理由に利用停止等を求めた場合、調査の上、必要に応じて対応し、結果を通知します。
                なお、対応が困難な場合は、代替措置を講じることがあります。
            </div>
            <h4>第9条（Cookie等の利用）</h4>
            <div class="mb-3">
                当サービスは、ユーザーの利用状況の把握やサービス改善のために、Cookie等の技術を用いることがあります。
            </div>
            <h4>第10条（プライバシーポリシーの変更）</h4>
            <div class="mb-3">
                本ポリシーは、法令の改正その他必要に応じて変更することがあります。
                重要な変更がある場合は、当サービスのウェブサイト上でお知らせします。
            </div>
            <h4>第11条（お問い合わせ窓口）</h4>
            <div class="mb-3">
                本ポリシーに関するお問い合わせは、以下のメールアドレスまでお願いいたします。
            </div>
            <dl>
                <dd>Eメールアドレス：</dd><dt>info@kashi-hondana.com</dt>
            </dl>
        </div>
    </div>
</template>


<style scoped lang="scss">
.rule {
    margin: 1rem 0;
    h3 {
        font-size: 1.3rem;
        border-bottom: 1px dashed #ddd;
        margin: .7rem 0;
        padding: .5rem 0;
    }
    h4 {
        font-size: 1.1rem;
        margin: 1.5rem 0 .7rem;
    }
}
</style>

<script>
export default {
    mounted() {
        this.useHead({
            title: "プライバシーポリシー | 貸し本棚",
            link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ]
        });
    }
}
</script>